import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import CustomModal from '../../../Modal';
import FormGroup from '../../../FormGroup';
import Loading from '../../../Loading';
import Timer from '../../../Timer';
import { I18nContext } from 'utils/I18n/context';

export const PaymentMethodActivation = ({
    id,
    searchMehod,
    timeToRenew: propTimeToRenew,
    activationPaymentDetails,
    onCancel,
    submitLinkConfirm,
    email,
    loadingActivationCode
}) => {
    const { t } = useContext(I18nContext);
    const [loading, setLoading] = useState(true);
    const [loadingActivation, setLoadingActivation] = useState(false);
    const [view, setView] = useState('warning');
    const [code, setCode] = useState('');
    const [timeToRenew, setTimeToRenew] = useState(0);
    const [errorsCode, setErrorsCode] = useState([]);

    useEffect(() => {
        searchMehod(id, () => {
            setLoading(false);
            setView(propTimeToRenew ? 'code' : 'warning');
            setTimeToRenew(propTimeToRenew);
        });
    }, [id, searchMehod, propTimeToRenew]);

    useEffect(() => {
        if (propTimeToRenew && !timeToRenew) {
            setTimeToRenew(propTimeToRenew);
        }
    }, [propTimeToRenew, timeToRenew]);

    useEffect(() => {
        if (loadingActivationCode === false && view !== 'code') {
            setView('code');
        }
    }, [loadingActivationCode, view]);

    const onSuccessActivation = () => {
        setLoadingActivation(false);
        onCancel();
    };

    const onErrorActivation = (error) => {
        setLoadingActivation(false);
        setErrorsCode(error);
    };

    const onActivationPaymentDetail = () => {
        setLoadingActivation(true);
        activationPaymentDetails(id, code, onSuccessActivation, onErrorActivation);
    };

    const onSendActivationCode = () => {
        submitLinkConfirm(id);
    };

    const onChangeCode = (event) => {
        setCode(event.target.value);
    };

    const onEndTimer = () => {
        setTimeToRenew(0);
    };

    const renderTimeOrSend = () => {
        const { methodActivation } = t?.paymentPage || {};
        const isDisable = timeToRenew > 0;

        return (
            <div className="big-field">
                {isDisable
                    ? (
                        <React.Fragment>
                            {`${methodActivation.timer} `}
                            <Timer time={timeToRenew} onStop={onEndTimer} />
                        </React.Fragment>
                    )
                    : <a href="#!" onClick={onSendActivationCode}>{methodActivation.repetSend}</a>
                }
            </div>
        );
    };

    const renderSendActivationCode = () => {
        const { methodActivation } = t?.paymentPage || {};

        return (
            <p>{methodActivation.text} <strong>{email}</strong>?</p>
        );
    };

    const renderSendCode = () => {
        const { methodActivation } = t?.paymentPage || {};

        return (
            <div className="form-horizontal activation">
                <FormGroup>
                    {methodActivation.textAfter}
                </FormGroup>
                <FormGroup
                    fieldClass="big-field"
                    label={methodActivation.labelToCode}
                    errors={errorsCode}
                    button={renderTimeOrSend()}
                >
                    <input
                        className="form-control"
                        value={code}
                        onChange={onChangeCode}
                    />
                </FormGroup>
            </div>
        );
    };

    const { methodActivation } = t?.paymentPage || {};
    const { send, activate } = t?.actions || {};
    const modalLoading = loadingActivationCode || loadingActivation;
    const isWarning = view === 'warning';
    const onConfirm = isWarning ? onSendActivationCode : onActivationPaymentDetail;

    return (
        <CustomModal
            visible={true}
            title={methodActivation.title}
            confirmName={isWarning ? send : activate}
            onClose={onCancel}
            onConfirm={onConfirm}
            bsSize={'sm'}
            loading={modalLoading}
        >
            {loading
                ? <Loading center={true} />
                : isWarning
                    ? renderSendActivationCode()
                    : renderSendCode()
            }
        </CustomModal>
    );
};

PaymentMethodActivation.propTypes = {
    id: PropTypes.string.isRequired,
    searchMehod: PropTypes.func.isRequired,
    timeToRenew: PropTypes.number,
    activationPaymentDetails: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    submitLinkConfirm: PropTypes.func.isRequired,
    email: PropTypes.string,
    loadingActivationCode: PropTypes.bool
};

PaymentMethodActivation.defaultProps = {
    timeToRenew: 0,
    email: '',
    loadingActivationCode: false
};
